import BootstrapInit from "../helper/BootstrapInit";
import RouteScrollToTop from "../helper/RouteScrollToTop";
import LoadPhosphorIcons from "../helper/LoadPhosphorIcons";

import "../font.css";
import "../globals.scss";

export default function RootLayout({ children }) {
  return (
    <div id="root-layout">
      <BootstrapInit />
      <LoadPhosphorIcons />
      <RouteScrollToTop />
      {children}
    </div>
  );
}
